import { Text } from '@pairy/pds-react';

import * as Styled from '../index.styles';

import Totle from './Totle';
import Stibee from './Stibee';
import MailChimp from './MailChimp';
import HubSpot from './HubSpot';
import ActiveCampaign from './ActiveCampaign';
import SalesforcePardot from './SalesforcePardot';

const item = {
  stibee: 'stibee',
  mailchimp: 'mailchimp',
  hubspot: 'hubspot',
  activeCampaign: 'activeCampaign',
  totle: 'totle',
  gmail: 'gmail',
  salesforce: 'salesforce',
  none: 'none',
} as const;

const BulkLinkCopyAccordion = () => {
  return (
    <div>
      <Text as="p" variant="lg-semibold" color="zinc_500">
        마케팅/메일 플랫폼으로 자료 보내고 싶을 땐
      </Text>
      <Styled.AccordionRoot type="multiple">
        <Styled.AccordionItem value={item.stibee}>
          <Stibee />
        </Styled.AccordionItem>
        <Styled.AccordionItem value={item.mailchimp}>
          <MailChimp />
        </Styled.AccordionItem>
        <Styled.AccordionItem value={item.hubspot}>
          <HubSpot />
        </Styled.AccordionItem>
        <Styled.AccordionItem value={item.activeCampaign}>
          <ActiveCampaign />
        </Styled.AccordionItem>
        <Styled.AccordionItem value={item.totle}>
          <Totle />
        </Styled.AccordionItem>
        <Styled.AccordionItem value={item.salesforce}>
          <SalesforcePardot />
        </Styled.AccordionItem>
      </Styled.AccordionRoot>
    </div>
  );
};

export default BulkLinkCopyAccordion;
